module.exports = __webpack_public_path__ + "static/media/navpreet-singh.1c36bef2.png";